import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useControlled } from '../../../../internal/hooks';

/**
 * Хук-контроллер, возвращающий подготовленное состояние
 * и обработчики событий для отдельных частей Tooltip-компонент
 *
 * Этот контроллер реализует поведение открытия/закрытия по клику
 *
 * @export
 * @param {IBaseTooltipProps} props
 * @returns
 */
export function useClickController(props) {
  var children = props.children,
      onClose = props.onClose,
      onOpen = props.onOpen;
  var childrenRef = React.useRef(null);
  var handleChildrenRef = useForkRef(children.ref, childrenRef);

  var _useControlled = useControlled({
    controlled: props.open,
    "default": false
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      open = _useControlled2[0],
      setOpen = _useControlled2[1];

  var handleClose = React.useCallback(function () {
    setOpen(false);

    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);

  var handleClick = function handleClick(event) {
    var childrenProps = children.props;

    if (childrenProps.onClick) {
      childrenProps.onClick(event);
    }

    setOpen(true);

    if (onOpen) {
      onOpen();
    }
  };

  var childrenProps = _objectSpread({}, children.props, {
    onClick: handleClick,
    ref: handleChildrenRef
  });

  return {
    childrenRef: childrenRef,
    childrenProps: childrenProps,
    open: open,
    handleClose: handleClose
  };
}